const isFluxPlusActive = false;

export default isFluxPlusActive;
